import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trDashEmpty',
})
@Injectable({ providedIn: 'root' })
export class DashEmptyPipe implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || value === null || value === '') {
      return '--';
    }

    return value;
  }
}
